export const NotificationIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4C9.23858 4 7 6.23858 7 9C7 10.1689 6.3964 11.4691 5.69602 12.405C5.25889 12.9891 5 13.7143 5 14.5C5 16.433 6.567 18 8.5 18H15.5C17.433 18 19 16.433 19 14.5C19 13.7143 18.7411 12.9891 18.304 12.405C17.8967 11.8607 17.5221 11.1932 17.2799 10.5M14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18M18 6C18 7.10457 17.1046 8 16 8C14.8954 8 14 7.10457 14 6C14 4.89543 14.8954 4 16 4C17.1046 4 18 4.89543 18 6Z"
        stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
